import { render, staticRenderFns } from "./manage-edit.vue?vue&type=template&id=776cae4e&"
import script from "./manage-edit.vue?vue&type=script&lang=js&"
export * from "./manage-edit.vue?vue&type=script&lang=js&"
import style0 from "./manage-edit.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports